<template>
  <div class="animated fadeIn">
    <b-card header="Search Filter">
      <b-form>
        <b-row>
          <b-col md="6" class="mb-3">
            <label for="keyword">Keyword</label>
            <b-input-group>
              <b-input-group-prepend><b-input-group-text><i class="icon-magnifier"/></b-input-group-text></b-input-group-prepend>
              <b-form-input id="keyword" v-model.trim="form.keyword" type="text" class="form-control" name="keyword" />
            </b-input-group>
          </b-col>
          <b-col md="6" class="mb-3">
            <label for="date">Date</label>
            <b-input-group>
              <b-input-group-prepend><b-input-group-text><i class="icon-calendar"/></b-input-group-text></b-input-group-prepend>
              <date-pick v-model="form.date" :display-format="'DD-MM-YYYY'" :input-attributes="{class:'form-control', id:'date', name:'date'}"/>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="mb-3">
            <label for="per_page">Item per Page</label>
            <b-form-select id="per-page" v-model="form.per_page" :options="perPageOptions" name="per_page" />
          </b-col>
        </b-row>
        <b-button :disabled="storeState.isChildLoading" variant="primary" @click="handleSearchCustomers">Search</b-button>
        <b-button :disabled="storeState.isChildLoading" variant="success" class="ml-2" @click="handleDownloadCustomers">Download</b-button>
      </b-form>
    </b-card>
    <b-card header="Customers List">
      <b-table v-if="items" :items="items" :fields="fields" bordered hover responsive class="text-nowrap">
        <template slot="gold_saldo" slot-scope="data">
          {{ data.item.gold_saldo }} gr
        </template>
      </b-table>
      <p v-if="!items" class="mb-0">No data</p>
      <b-pagination v-if="items && totalRows > params.per_page" :disabled="storeState.isChildLoading" :total-rows="totalRows" v-model="params.page" :per-page="params.per_page" align="center" first-text="First" prev-text="Prev" next-text="Next" last-text="Last" size="md" class="mt-4" @change="updateQueryString" />
    </b-card>
  </div>
</template>

<script>
import DatePick from 'vue-date-pick'
import { store } from '@/shared/store'
import { handleDownloadFile } from '@/shared/utils'
import { getCustomersList, getCustomersListCsv, handleError } from '@/services/metal'

export default {
  name: 'CustomersList',
  components: { DatePick },

  data() {
    return {
      params: {},
      form: {},
      perPageOptions: [
        { value: 10, text: '10' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
        { value: 75, text: '75' },
        { value: 100, text: '100' }
      ],
      fields: [
        'date',
        'id',
        'external_id',
        'name',
        'phone_number',
        'email',
        'gold_saldo',
      ],
      items: null,
      totalRows: 0,
      storeState: store.state,
    }
  }, // data

  watch: {
    '$route': function() {
      store.setIsChildLoading(true)
      this.getCustomersList()
    }
  }, // watch

  created() {
    store.setIsInitLoading(true)
    this.getCustomersList()
  }, // created

  methods: {
    getCustomersList() {
      store.setIsProcessing(true)

      // assign default value
      this.params = {
        page: 1,
        keyword: '',
        status: '',
        date: '',
        per_page: 10,
      }

      // overwrite value from query string
      if (Object.keys(this.$route.query).length > 0) {
        if (this.$route.query.page) {
          this.$route.query.page = parseInt(this.$route.query.page)
        }

        if (this.$route.query.per_page) {
          this.$route.query.per_page = parseInt(this.$route.query.per_page)
        }

        this.params = Object.assign(this.params, this.$route.query)
      }

      // overwrite form value
      this.form = Object.assign({}, this.params)

      let reqData = {
        search: this.params.keyword,
        date: this.params.date,
        offset: (this.params.page-1)*this.params.per_page,
        limit: this.params.per_page,
      }

      getCustomersList(reqData)
        .then( response => {
          if (response.data.data.total_data != 0) {
            this.items = response.data.data.customers
            this.totalRows = response.data.data.total_data
          } else {
            this.items = null
            this.totalRows = 0
          }
          store.setIsInitLoading(false)
        })
        .catch( error => {
          handleError(error)
        })
        .then( () => {
          store.clearProcessing()
        })
    },

    updateQueryString(page) {
      this.params.page = page
      this.$router.push({ path: '/customers-list', query: this.params})
    },

    handleSearchCustomers() {
      // overwrite params value using form value
      this.params = Object.assign(this.params, this.form)
      this.updateQueryString(1)
    },

    handleDownloadCustomers() {
      // overwrite params value using form value
      this.params = Object.assign(this.params, this.form)

      let reqData = {
        search: this.params.keyword,
        date: this.params.date,
      }

      getCustomersListCsv(reqData)
        .then( response => {
          handleDownloadFile(response)
          store.setIsInitLoading(false)
        })
        .catch( error => {
          handleError(error)
        })
        .then( () => {
          store.clearProcessing()
        })
    },

  }, // methods
}
</script>
